import { defineStore } from "pinia";
import { checkLogin, queryUserInfo } from "@/api/site-home/index";
import { errorInfoDis } from "@/utils/project-utils";

export interface UserState {
  userName?: string;
  subjectName?: string;
  userRole: number[];
  menuKey: string;
}

export const useUserStore = defineStore({
  id: "user",
  state: (): UserState => ({
    userName: undefined,
    subjectName: "",
    userRole: [],
    menuKey: "/",
  }),
  getters: {},
  actions: {
    async fetchUserInfo() {
      try {
        const result = await checkLogin();
        if (!result) {
          return {};
        }
        this.userName = result.userName;
        this.subjectName = result.subjectName;
        const userInfo = await queryUserInfo();
        if (userInfo) {
          this.userRole =
            userInfo?.currentUser?.subjectRoles?.map(
              (item: any) => item.label
            ) || [];
        }
      } catch (error: any) {
        errorInfoDis(error.message || "请求用户信息失败");
        return false;
      }
    },
    setUserRole(roleKey: number[]) {
      this.userRole = roleKey;
    },
    setMenuKey(key: string) {
      this.menuKey = key;
    },
  },
});
